// ** React Imports
import { useEffect } from "react";
import { NavLink } from "react-router-dom";

// ** Icons Imports
import { Disc, X, Circle } from "react-feather";

// ** Config
import themeConfig from "@configs/themeConfig";
import * as Constants from "../../../../../constants";

const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setMenuCollapsed,
    setMenuVisibility,
    setGroupOpen,
    menuHover,
  } = props;
  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed]);

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      );
    } else {
      return (
        <Circle
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      );
    }
  };

  const logoCompany = localStorage.getItem("logoCompany");
  const company = JSON.parse(localStorage.getItem("company"));
  const brandUrl = company?.logo_url ?? logoCompany ?? themeConfig.app.appLogoImage;
  const brandName = company?.company_name ?? Constants.NAME_APP;
  
  return (
    <div className="navbar-header">
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item me-auto" style={{ marginTop: "-15px" }}>
          <a href="/" className="navbar-brand">
            <span
              className="brand-logo"
              style={{
                border: "1px solid #D8D6DE",
                borderRadius: "50%",
                padding: "2px 2px",
              }}
              title={brandName}
            >
              <img
                style={{ marginBottom: "unset" }}
                src={brandUrl}
                alt="logo"
              />
            </span>
            <span
              style={{
                fontWeight: "bold",
                fontSize: "21px",
                marginLeft: "21px",
                color: "#2D58AF",
                maxWidth: "120px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={brandName}
            >
              {brandName}
            </span>
          </a>
        </li>
        <li className="nav-item nav-toggle" style={{ marginTop: "-6px" }}>
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <Toggler />
            <X
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block d-xl-none"
              size={20}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default VerticalMenuHeader;
